import React from "react";

import {
  Box,
  Typography,
  
  GlobalStyles,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  tabClasses,
} from "@mui/joy";
import {
  GitHub,
  School,
  Work,
  Star,
  LinkedIn,
  Twitter,
  Email,
  Code,
  Storage,
  Cloud,
  Brush,
} from "@mui/icons-material";
import ProjectCards from "./ProjectCards";

function Home() {
  return (
    <Box>
      <Box
        sx={{
          width: "100%", // Ensures the background spans the full width of the viewport
          minHeight: { xs: "500px", md: "400px" }, // Dynamic height based on screen size
          // Replace solid background with gradient
          // Enhanced gradient with more colors
          background:
            "linear-gradient(135deg, #822424 0%, #541e6b 25%, #a13030 50%, #1e2b54 75%, #c13c3c 100%)",
          display: "flex", // Flexbox for centering
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          padding: { xs: "15px", md: "20px" }, // Smaller padding on mobile
          overflow: "hidden", // Prevent horizontal scrolling
          position: "relative", // Needed for absolute positioning of planets
        }}
      >
        {/* First planet */}
        <Box
          sx={{
            position: "absolute",
            width: { xs: "60px", md: "80px" }, // Smaller on mobile
            height: { xs: "60px", md: "80px" },
            borderRadius: "50%",
            background: "radial-gradient(circle, #f9d423 0%, #ff4e50 100%)",
            boxShadow: "0 0 20px 5px rgba(249, 212, 35, 0.5)",
            opacity: 0.6,
            left: "10%",
            top: "30%",
            animation: "planetMove1 30s infinite linear",
            zIndex: 0,
          }}
        />

        {/* Second planet */}
        <Box
          sx={{
            position: "absolute",
            width: { xs: "80px", md: "120px" }, // Smaller on mobile
            height: { xs: "80px", md: "120px" },
            borderRadius: "50%",
            background: "radial-gradient(circle, #00d2ff 0%, #3a7bd5 100%)",
            boxShadow: "0 0 30px 10px rgba(0, 210, 255, 0.3)",
            opacity: 0.6,
            right: "10%",
            top: "60%",
            animation: "planetMove2 50s infinite linear",
            zIndex: 0,
          }}
        />

        {/* Third planet */}
        <Box
          sx={{
            position: "absolute",
            width: { xs: "40px", md: "60px" }, // Smaller on mobile
            height: { xs: "40px", md: "60px" },
            borderRadius: "50%",
            background: "radial-gradient(circle, #a8ff78 0%, #78ffd6 100%)",
            boxShadow: "0 0 25px 5px rgba(168, 255, 120, 0.4)",
            opacity: 0.7,
            left: "15%",
            top: "20%",
            animation: "planetMove3 20s infinite linear",
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            position: "relative", // Needed for the glowing circle
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Card */}
          <Box
            sx={{
              width: "900px",
              maxWidth: "900px", // Maximum width on larger screens
              padding: { xs: "15px", md: "20px" },
              borderRadius: "20px",
              backgroundColor: "white",
              display: "flex", // Flexbox for horizontal layout
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center", // Center items vertically
              gap: { xs: "20px", md: "40px" }, // Less gap on mobile
              overflow: "hidden", // Prevent content overflow
            }}
          >
            {/* Profile Image */}
            <Box
              sx={{
                width: { xs: "180px", sm: "180px", md: "240px" },
                height: { xs: "180px", sm: "180px", md: "240px" },
                borderRadius: "50%",
                overflow: "hidden",
                border: "4px solid white",
                flexShrink: 0,
              }}
            >
              <img
                src="/mary-ann-wambui.jpeg"
                alt="Mary Ann Wambui, Full Stack Developer"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* Card Content */}
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" }, // Center text on mobile
                width: "100%",
              }}
            >
              <Typography
                level="h1"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: "10px",
                  fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" }, // Added specific size
                }}
              >
                Hi! I'm Mary Ann Wambui
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: { xs: "center", md: "flex-start" }, // C
                  gap: "10px",
                  maxWidth: { xs: "100%", md: "300px" }, // Full width on mobile
                  marginBottom: "10px",
                }}
              >
                {/* Styled Letters */}
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#00b4d8",
                    backgroundColor: "#D2B48C",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(-5deg)",
                    fontFamily: "Impact, Charcoal, sans-serif",
                  }}
                >
                  F
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "black",
                    backgroundColor: "#D2B48C",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(3deg)",
                    fontFamily: "'Comic Sans MS', cursive, sans-serif",
                  }}
                >
                  U
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "black",
                    backgroundColor: "#FE7743",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(-8deg)",
                    fontFamily: "Impact, Charcoal, sans-serif",
                  }}
                >
                  L
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#000000",
                    backgroundColor: "#FE7743",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(5deg)",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  L
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#D2B48C",
                    backgroundColor: "black",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(-3deg)",
                    fontFamily: "'Times New Roman', Times, serif",
                  }}
                >
                  S
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#C5172E",
                    backgroundColor: "#D2B48C",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(3deg)",
                    fontFamily: "'Comic Sans MS', cursive, sans-serif",
                  }}
                >
                  T
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "whitesmoke",
                    backgroundColor: "#504C57",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(-8deg)",
                    fontFamily: "Impact, Charcoal, sans-serif",
                  }}
                >
                  A
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#BB3E00",
                    backgroundColor: "#D2B48C",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(5deg)",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  C
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "24px", md: "30px" },
                    fontWeight: "bold",
                    color: "#00b4d8",
                    backgroundColor: "#D2B48C",
                    padding: "2px",
                    borderRadius: "5px",
                    transform: "rotate(-3deg)",
                    fontFamily: "'Times New Roman', Times, serif",
                  }}
                >
                  K
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }, // Stack vertically on mobile
                  alignItems: "center",
                  width: "100%",
                  marginBottom: "15px",
                  color: "#666",
                  fontSize: "14px",
                  gap: { xs: "10px", md: 0 }, // Add gap when stacked
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    padding: "6px",

                    borderRight: { xs: "none", md: "1px solid #ddd" },
                    borderTop: { xs: "none", md: "2px solid #ddd" },
                    borderBottom: "2px solid #ddd",
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", md: "14px" },
                      color: "#666",
                      wordBreak: "break-word", // Prevents email from overflowing
                    }}
                  >
                    maryannewambui0124@gmail.com
                  </Typography>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    padding: "6px",
                    borderTop: { xs: "none", md: "2px solid #ddd" },
                    borderBottom: "2px solid #ddd",
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", md: "14px" },
                      color: "#666",
                      paddingLeft: { xs: 0, md: "4px" },
                    }}
                  >
                    Nairobi, Kenya
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: "13px", md: "14px" },
                  color: "black",
                  lineHeight: "1.5",
                  textAlign: { xs: "center", md: "left" }, // Center o
                }}
              >
                I am a full-stack developer and entrepreneur who enjoys turning ideas into meaningful digital experiences. When I’m not coding, I love reading, traveling, and spending quality time with my family. I believe that <strong><em>"Good things take time"</em></strong>
                .
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <GlobalStyles
        styles={{
          "@keyframes planetMove1": {
            "0%": { transform: "translate(0, 0)" },
            "25%": { transform: "translate(100px, 40px)" },
            "50%": { transform: "translate(200px, 0)" },
            "75%": { transform: "translate(100px, -40px)" },
            "100%": { transform: "translate(0, 0)" },
          },
          "@keyframes planetMove2": {
            "0%": { transform: "translate(0, 0) rotate(0deg)" },
            "100%": {
              transform: "translate(0, 0) rotate(360deg) translate(-120px, 0)",
            },
          },
          "@keyframes planetMove3": {
            "0%": { transform: "translate(0, 0)" },
            "33%": { transform: "translate(60px, 50px)" },
            "66%": { transform: "translate(-60px, 50px)" },
            "100%": { transform: "translate(0, 0)" },
          },
          "@keyframes planetMove4": {
            "0%": { transform: "scale(1) translate(0, 0)" },
            "50%": { transform: "scale(1.3) translate(-40px, -20px)" },
            "100%": { transform: "scale(1) translate(0, 0)" },
          },
        }}
      />
      {/* Technical Skills Heading */}
      <Box sx={{ textAlign: "center", marginTop: "40px", marginBottom: "8px" }}>
        <Typography
          level="h1"
          sx={{
            fontWeight: "800",
            color: "#1a1a2e",
            display: "inline-block",
            position: "relative",
            "&::after": {
              content: '""',
              display: "block",
              height: "4px",
              borderRadius: "2px",
              marginTop: "6px",
              background:
                "linear-gradient(90deg, #822424, #541e6b, #1e2b54, #a13030)",
            },
          }}
        >
          Technical Skills
        </Typography>
        <Typography
          sx={{ color: "#666", marginTop: "8px", fontSize: "1rem" }}
        >
          Tools and technologies I work with
        </Typography>
      </Box>

      <Box
        sx={{
          padding: { xs: "20px", md: "40px" },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "1fr 1fr 1fr 1fr",
            },
            gap: "24px",
          }}
        >
          {[
            {
              title: "Frontend",
              icon: <Code sx={{ fontSize: "22px", color: "white" }} />,
              accent: "#822424",
              accentLight: "rgba(130, 36, 36, 0.08)",
              skills: ["React.js", "HTML", "CSS", "JavaScript", "Material-UI", "Bootstrap", "React Native", "C#"],
            },
            {
              title: "Backend",
              icon: <Storage sx={{ fontSize: "22px", color: "white" }} />,
              accent: "#541e6b",
              accentLight: "rgba(84, 30, 107, 0.08)",
              skills: ["Python", "Django", "Node.js", "RESTful APIs", "PostgreSQL", "MySQL", "ASP.NET"],
            },
            {
              title: "DevOps",
              icon: <Cloud sx={{ fontSize: "22px", color: "white" }} />,
              accent: "#1e2b54",
              accentLight: "rgba(30, 43, 84, 0.08)",
              skills: ["Git", "Docker", "AWS", "CI/CD", "Kubernetes", "Azure", "MonsterASP.NET",],
            },
            {
              title: "Design",
              icon: <Brush sx={{ fontSize: "22px", color: "white" }} />,
              accent: "#a13030",
              accentLight: "rgba(161, 48, 48, 0.08)",
              skills: ["Figma", "Sketch", "Canva", "Logo Design", "UI/UX Design"],
            },
          ].map((category) => (
            <Box
              key={category.title}
              sx={{
                backgroundColor: "white",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.06)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: `0 12px 32px ${category.accent}33`,
                },
              }}
            >
              {/* Colored top bar with icon and title */}
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${category.accent}cc, ${category.accent})`,
                  padding: "18px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Box
                  sx={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {category.icon}
                </Box>
                <Typography
                  level="h4"
                  sx={{
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.1rem",
                    letterSpacing: "0.3px",
                  }}
                >
                  {category.title}
                </Typography>
              </Box>

              {/* Skill tags */}
              <Box
                sx={{
                  padding: "18px 16px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {category.skills.map((skill) => (
                  <Typography
                    key={skill}
                    sx={{
                      backgroundColor: category.accentLight,
                      color: category.accent,
                      padding: "5px 12px",
                      borderRadius: "20px",
                      fontSize: "0.82rem",
                      fontWeight: "600",
                      border: `1px solid ${category.accent}22`,
                      transition: "background-color 0.2s ease",
                      "&:hover": {
                        backgroundColor: `${category.accent}18`,
                      },
                    }}
                  >
                    {skill}
                  </Typography>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Projects Section */}
      <Box sx={{ textAlign: "center", marginTop: "40px", marginBottom: "8px" }}>
        <Typography
          level="h1"
          sx={{
            fontWeight: "800",
            color: "#1a1a2e",
            display: "inline-block",
            position: "relative",
            "&::after": {
              content: '""',
              display: "block",
              height: "4px",
              borderRadius: "2px",
              marginTop: "6px",
              background: "linear-gradient(90deg, #822424, #541e6b, #1e2b54, #a13030)",
            },
          }}
        >
          Projects
        </Typography>
        <Typography sx={{ color: "#666", marginTop: "8px", fontSize: "1rem" }}>
          A selection of things I've built
        </Typography>
      </Box>

      <ProjectCards />
      {/* Journey Section */}
      <Box sx={{ textAlign: "center", marginTop: "40px", marginBottom: "8px" }}>
        <Typography
          level="h1"
          sx={{
            fontWeight: "800",
            color: "#1a1a2e",
            display: "inline-block",
            position: "relative",
            "&::after": {
              content: '""',
              display: "block",
              height: "4px",
              borderRadius: "2px",
              marginTop: "6px",
              background:
                "linear-gradient(90deg, #822424, #541e6b, #1e2b54, #a13030)",
            },
          }}
        >
          My Journey
        </Typography>
        <Typography sx={{ color: "#666", marginTop: "8px", fontSize: "1rem" }}>
          Shaped me
        </Typography>
      </Box>

      <Box
        sx={{
          padding: { xs: "20px", md: "40px" },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Tabs
          defaultValue={0}
          sx={{
            backgroundColor: "transparent",
            borderRadius: "16px",
            overflow: "visible",
          }}
        >
          {/* Tab bar */}
          <TabList
            sx={{
              background:
                "linear-gradient(135deg, #822424 0%, #541e6b 60%, #1e2b54 100%)",
              p: "6px",
              gap: 1,
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(84,30,107,0.3)",
              mb: 3,
              [`& .${tabClasses.root}`]: {
                color: "rgba(255,255,255,0.75)",
                fontWeight: "600",
                fontSize: "0.9rem",
                borderRadius: "8px",
                flex: 1,
                py: "10px",
                transition: "all 0.25s ease",
                [`&.${tabClasses.selected}`]: {
                  color: "#541e6b",
                  bgcolor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
                },
                [`&:hover:not(.${tabClasses.selected})`]: {
                  bgcolor: "rgba(255,255,255,0.15)",
                  color: "white",
                },
              },
            }}
          >
            <Tab startDecorator={<Work sx={{ fontSize: "18px" }} />}>Experience</Tab>
            <Tab startDecorator={<School sx={{ fontSize: "18px" }} />}>Education</Tab>
            <Tab startDecorator={<Star sx={{ fontSize: "18px" }} />}>Certifications</Tab>
          </TabList>

          {/* Experience Tab */}
          <TabPanel value={0} sx={{ p: 0 }}>
            <Box sx={{ position: "relative", pl: "28px" }}>
              {/* Vertical timeline line */}
              <Box sx={{
                position: "absolute",
                left: "9px",
                top: "12px",
                bottom: "12px",
                width: "2px",
                background: "linear-gradient(180deg, #822424, rgba(130,36,36,0.1))",
                borderRadius: "2px",
              }} />

              {[
                {
                  role: "Full Stack Developer",
                  company: "Moconnect",
                  period: "2023 – Present",
                  description:
                    "Leading the development of an e-commerce platform using React and Django. Implemented real-time inventory management and secure payment integration.",
                },
                {
                  role: "Front-End Developer Intern",
                  company: "Real Biz Digital",
                  period: "2024",
                  description:
                    "Developed the UX/UI design of their survey platform, collaborated with the team and integrated third-party APIs.",
                },
              ].map((exp, index) => (
                <Box key={index} sx={{ position: "relative", mb: 3 }}>
                  {/* Timeline dot */}
                  <Box sx={{
                    position: "absolute",
                    left: "-23px",
                    top: "18px",
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#822424",
                    border: "3px solid white",
                    boxShadow: "0 0 0 2px #822424",
                  }} />

                  <Box
                    sx={{
                      p: "20px 22px",
                      borderRadius: "12px",
                      backgroundColor: "white",
                      border: "1px solid rgba(130,36,36,0.1)",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateX(8px)",
                        boxShadow: "0 6px 24px rgba(130,36,36,0.15)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 1, mb: 1 }}>
                      <Typography level="h4" sx={{ color: "#822424", fontWeight: "700", fontSize: "1.05rem" }}>
                        {exp.role}
                      </Typography>
                      <Typography sx={{
                        fontSize: "0.75rem",
                        fontWeight: "600",
                        color: "#822424",
                        backgroundColor: "rgba(130,36,36,0.08)",
                        px: "10px",
                        py: "3px",
                        borderRadius: "20px",
                        border: "1px solid rgba(130,36,36,0.18)",
                        whiteSpace: "nowrap",
                      }}>
                        {exp.period}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.88rem", color: "#888", fontWeight: "600", mb: "10px" }}>
                      {exp.company}
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "#555", lineHeight: 1.7 }}>
                      {exp.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </TabPanel>

          {/* Education Tab */}
          <TabPanel value={1} sx={{ p: 0 }}>
            <Box sx={{ position: "relative", pl: "28px" }}>
              <Box sx={{
                position: "absolute",
                left: "9px",
                top: "12px",
                bottom: "12px",
                width: "2px",
                background: "linear-gradient(180deg, #541e6b, rgba(84,30,107,0.1))",
                borderRadius: "2px",
              }} />

              {[
                {
                  degree: "Diploma in Business Information Technology",
                  school: "Technical University of Kenya",
                  period: "2021 – 2024",
                  description:
                    "Specialized in Programming, Marketing and Business. Graduated with Credit (Lower Division).",
                },
                {
                  degree: "DevOps and Cloud Native Course",
                  school: "Strathmore University",
                  period: "2025 · 3 months",
                  description: "Specializing in Docker and making deployments.",
                },
                {
                  degree: "Bachelor of Science in Business Information Technology",
                  school: "Technical University of Kenya",
                  period: "May 2026 – Present",
                  description:
                    "Currently pursuing a degree focused on the intersection of business and technology, covering systems analysis, enterprise software, data management, and IT project management.",
                },
              ].map((edu, index) => (
                <Box key={index} sx={{ position: "relative", mb: 3 }}>
                  <Box sx={{
                    position: "absolute",
                    left: "-23px",
                    top: "18px",
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#541e6b",
                    border: "3px solid white",
                    boxShadow: "0 0 0 2px #541e6b",
                  }} />

                  <Box
                    sx={{
                      p: "20px 22px",
                      borderRadius: "12px",
                      backgroundColor: "white",
                      border: "1px solid rgba(84,30,107,0.1)",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateX(8px)",
                        boxShadow: "0 6px 24px rgba(84,30,107,0.15)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 1, mb: 1 }}>
                      <Typography level="h4" sx={{ color: "#541e6b", fontWeight: "700", fontSize: "1.05rem" }}>
                        {edu.degree}
                      </Typography>
                      <Typography sx={{
                        fontSize: "0.75rem",
                        fontWeight: "600",
                        color: "#541e6b",
                        backgroundColor: "rgba(84,30,107,0.08)",
                        px: "10px",
                        py: "3px",
                        borderRadius: "20px",
                        border: "1px solid rgba(84,30,107,0.18)",
                        whiteSpace: "nowrap",
                      }}>
                        {edu.period}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.88rem", color: "#888", fontWeight: "600", mb: "10px" }}>
                      {edu.school}
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "#555", lineHeight: 1.7 }}>
                      {edu.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </TabPanel>

          {/* Certifications Tab */}
          <TabPanel value={2} sx={{ p: 0 }}>
            <Box sx={{ position: "relative", pl: "28px" }}>
              <Box sx={{
                position: "absolute",
                left: "9px",
                top: "12px",
                bottom: "12px",
                width: "2px",
                background: "linear-gradient(180deg, #1e2b54, rgba(30,43,84,0.1))",
                borderRadius: "2px",
              }} />

              {[
                {
                  name: "Data Science",
                  issuer: "Zalego Academy",
                  date: "2021",
                  description:
                    "Gained hands-on experience using statistical methods to analyze and interpret data, making inferences and predictions from data sets, and understanding probability and distributions.",
                },
                {
                  name: "Digital Safety: Cyber Security",
                  issuer: "Udemy",
                  date: "2024",
                  description:
                    "Learnt the fundamentals of Cyber Security and gained practical hands-on experience with security tools and techniques.",
                },
              ].map((cert, index) => (
                <Box key={index} sx={{ position: "relative", mb: 3 }}>
                  <Box sx={{
                    position: "absolute",
                    left: "-23px",
                    top: "18px",
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    backgroundColor: "#1e2b54",
                    border: "3px solid white",
                    boxShadow: "0 0 0 2px #1e2b54",
                  }} />

                  <Box
                    sx={{
                      p: "20px 22px",
                      borderRadius: "12px",
                      backgroundColor: "white",
                      border: "1px solid rgba(30,43,84,0.1)",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateX(8px)",
                        boxShadow: "0 6px 24px rgba(30,43,84,0.15)",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 1, mb: 1 }}>
                      <Typography level="h4" sx={{ color: "#1e2b54", fontWeight: "700", fontSize: "1.05rem" }}>
                        {cert.name}
                      </Typography>
                      <Typography sx={{
                        fontSize: "0.75rem",
                        fontWeight: "600",
                        color: "#1e2b54",
                        backgroundColor: "rgba(30,43,84,0.08)",
                        px: "10px",
                        py: "3px",
                        borderRadius: "20px",
                        border: "1px solid rgba(30,43,84,0.18)",
                        whiteSpace: "nowrap",
                      }}>
                        {cert.date}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.88rem", color: "#888", fontWeight: "600", mb: "10px" }}>
                      {cert.issuer}
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "#555", lineHeight: 1.7 }}>
                      {cert.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </TabPanel>
        </Tabs>
      </Box>

      {/* Footer Section */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #822424 0%, #541e6b 25%, #a13030 50%, #1e2b54 75%, #c13c3c 100%)",
          color: "white",
          padding: { xs: "20px", md: "40px" },
          marginTop: "40px",
          position: "relative", // Add this for potential overlay effects
          "&::before": {
            // Optional: Add a slight overlay to ensure text readability
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "center", md: "flex-start" },
            gap: { xs: "20px", md: "0" },
            position: "relative", // Add this to place content above the overlay
            zIndex: 2,
          }}
        >
          {/* Left Side - Name and Copyright */}
          <Box
            sx={{
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              level="h4"
              sx={{
                fontWeight: "bold",
                marginBottom: "8px",
                color: "white",
              }}
            >
              Mary Ann Wambui
            </Typography>
            <Typography
              sx={{
                fontSize: "0.9rem",
                opacity: 0.8,
                color: "white",
              }}
            >
              © {new Date().getFullYear()} All rights reserved
            </Typography>
          </Box>

          {/* Right Side - Social Links */}
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
            }}
          >
            {[
              {
                icon: <GitHub sx={{ fontSize: "22px", color: "white" }} />,
                link: "https://github.com/marywam",
                label: "GitHub",
              },
              {
                icon: <LinkedIn sx={{ fontSize: "22px", color: "white" }} />,
                link: "https://www.linkedin.com/in/maryanne-wambui-7b6476289/",
                label: "LinkedIn",
              },
              {
                icon: <Twitter sx={{ fontSize: "22px", color: "white" }} />,
                link: "https://twitter.com/YourTwitterHandle",
                label: "Twitter",
              },
              {
                icon: <Email sx={{ fontSize: "22px", color: "white" }} />,
                link: "https://mail.google.com/mail/u/0/#inbox",
                label: "Email",
              },
            ].map((social, index) => (
              <Box
                key={index}
                component="a"
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                sx={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "50%",
                  border: "1.5px solid rgba(255, 255, 255, 0.5)",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  backdropFilter: "blur(4px)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    backgroundColor: "rgba(255, 255, 255, 0.25)",
                    border: "1.5px solid rgba(255, 255, 255, 0.9)",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
                  },
                }}
              >
                {social.icon}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Home;
